import "./App.css"
import "./components/common/common.css"
import Header from "./components/common/header/Header"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import About from "./components/about/About"
import CourseHome from "./components/allcourses/CourseHome"
import Team from "./components/team/Team"
import Pricing from "./components/pricing/Pricing"
import Blog from "./components/blog/Blog"
import Contact from "./components/contact/Contact"
import PhotoGallery from "./components/blog/PhotoGallery"
import Footer from "./components/common/footer/Footer"
import Home from "./components/home/Home"
import NotificationProvider from "./components/common/NotificationProvider"
import { useOnlineStatus } from "./hooks/useAutoRefresh"
import { useEffect, useState } from "react"
import Branch from "./components/branch/Branch"

function App() {
  const isOnline = useOnlineStatus()
  const [showOfflineMessage, setShowOfflineMessage] = useState(false)

  useEffect(() => {
    if (!isOnline) {
      setShowOfflineMessage(true)
      const timer = setTimeout(() => setShowOfflineMessage(false), 5000)
      return () => clearTimeout(timer)
    }
  }, [isOnline])

  return (
    <NotificationProvider>
      <Router>
        {showOfflineMessage && (
          <div className="offline-banner">
            <span>⚠️ You're currently offline. Some features may not work properly.</span>
          </div>
        )}
        <Header />
        <main role="main">
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/about' element={<About />} />
            <Route exact path='/branch' element={<Branch />} />
            <Route exact path='/courses' element={<CourseHome />} />
            <Route exact path='/team' element={<Team />} />
            <Route exact path='/pricing' element={<Pricing />} />
            <Route exact path='/journal' element={<Blog />} />
            <Route exact path='/contact' element={<Contact />} />
            <Route exact path='/photos' element={<PhotoGallery />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </NotificationProvider>
  )
}

export default App
